import { IDriver } from "@interfaces/IDriver";
import { IJourney } from "@interfaces/IJourney";
import { IPlotEvent } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { VehicleService } from "@services/vehicle.service";
import * as angular from "angular";
import * as moment from "moment";
import { CameraDisplayService } from "../../cameraDisplay.service";
import { VideoStatus } from "../../enums/VideoStatus";
import { CameraService } from "../../services/camera.service";
import "./journeySummaryCard.scss";


class JourneySummaryCardComponentController implements angular.IComponentController {

    journey: IJourney;
    vehicle: IVehicle;
    driver: IDriver;

    videoStatus = VideoStatus;

    journeyEvents: IPlotEvent[];

    lastSelectedEvent: IPlotEvent;

    selectedDay: Date;

    eventCardClick: (args: { event: IPlotEvent }) => void;
    eventCardHover: (args: { event: IPlotEvent }) => void;

    static $inject = ["cameraService", "cameraDisplayService", "vehicleService"];

    constructor(
        private readonly cameraService: CameraService,
        private readonly cameraDisplayService: CameraDisplayService,
        private readonly vehicleService: VehicleService
    ) {
    }

    $onInit() {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.lastSelectedEvent = null;
        this.sortJourneyEvents();
        this.updateEvents();
    }
    
    onEventCardClick(event: IPlotEvent) {

        if (this.lastSelectedEvent == event) {
            this.lastSelectedEvent = null;
        }
        else {
            this.lastSelectedEvent = event;
        }

        if (this.eventCardClick) {
            this.eventCardClick({ event: event });
        }
    }

    onEventFooterClick(event: IPlotEvent, $event: MouseEvent) {
        if (!event.video.vehicle) {
            this.vehicleService.getVehicle(event.video.VehicleId, { includePeripheralMappings: true }).then(vehicle => {
                event.video.vehicle = vehicle;
            });           
        }

        this.cameraDisplayService.showVideoPlayer(event.video, $event);
    }

    onEventListHover(event: IPlotEvent) {
        if (this.eventCardHover) {
            this.eventCardHover({ event: event });
        }
    }

    private sortJourneyEvents() {
        this.journey.events.sort((a, b) => {
            return moment(a.Utc).isBefore(b.Utc) ? -1 : 1;
        });
    }

    private updateEvents() {
        this.journeyEvents = this.cameraService.getFilteredEventsForVideo(this.journey.events);
    }
}

export class JourneySummaryCardComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {
            vehicle: "<",
            driver: "<",
            journey: "<",
            selectedDay: "<",
            eventCardClick: "&",
            eventCardHover: "&"
        };

        this.controller = JourneySummaryCardComponentController;

        this.template = require("./journeySummaryCard.html");
    }
}
